import React from "react"
import "./style.scss";
import { QuestionData } from "../../global-interfaces";
import Classnames from "classnames";
import { returnFormatSrtringArray } from "../../utils"

interface AnnotationProps {
  annotation: QuestionData[];
}

export default function Annotation ({ annotation } : AnnotationProps ) {
  return (
    <div
      className={Classnames("Annotation", {
        "narrow-margin": annotation.length > 500,
      })}
    >
      <div className="content"
        style={{ 
          // if any of the following are a list, they should flex-start, otherwise, space-around.
          justifyContent: annotation.reduce((t,v) => t || v.label_group === "footnote", false) ? "space-between" : "flex-start" 
        }}>
        {annotation.map((d, i) => (
          <div key={i} className={d.label_group}>
            {returnFormatSrtringArray(d.label).map(([classKey, string], i) => <span key={i} className={classKey}>
              {string}
              </span>)}
          </div>
        ))}
      </div>
    </div>
  );
}